
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export function SoftwareHero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 200);
  }, []);

  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20modern%20office%20desk%20with%20computer%20monitors%20showing%20software%20license%20certificates%20and%20digital%20security%20shields%2C%20subtle%20cyan%20and%20teal%20neon%20lighting%20accents%2C%20professional%20IT%20environment%2C%20clean%20minimal%20dark%20background%20with%20glowing%20elements%2C%20technology%20workspace&width=1920&height=900&seq=sw-hero-1&orientation=landscape"
          alt="Software Legal - Licencias originales y programas certificados"
          title="Software Legal STI - Licencias originales"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-950/75 via-gray-950/65 to-gray-950/85"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-neon-400 transition-colors mb-6 cursor-pointer text-sm">
            <i className="ri-arrow-left-line"></i>
            <span>Volver al inicio</span>
          </Link>

          <p className="text-xs sm:text-sm tracking-widest uppercase text-neon-400 mb-4 font-medium">Licencias &amp; Programas Originales</p>

          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
            <strong>Software</strong>{' '}
            <span className="text-neon-400 text-neon-glow">Legal</span>
          </h1>

          <p className="text-sm sm:text-lg text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
            Protegé tu empresa con <strong className="text-white">licencias originales y certificadas</strong>. 
            Cumplimiento normativo, seguridad garantizada y soporte técnico incluido en cada solución.
          </p>

          <a
            href="#licencias"
            className="inline-flex items-center gap-2 px-6 py-3 bg-gray-800/50 backdrop-blur-sm text-white text-sm font-semibold rounded-lg border border-neon-400/40 hover:bg-gray-700/60 hover:border-neon-400 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-shield-2-line"></i>
            Ver Licencias Disponibles
          </a>
        </div>
      </div>
    </section>
  );
}
